import { render, staticRenderFns } from "./dash.vue?vue&type=template&id=6b530c14&scoped=true&"
import script from "./dash.vue?vue&type=script&lang=ts&"
export * from "./dash.vue?vue&type=script&lang=ts&"
import style0 from "./dash.vue?vue&type=style&index=0&id=6b530c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b530c14",
  null
  
)

export default component.exports